module.exports = __webpack_public_path__ + "static/media/zncf.d0b7c766.png";